import React from 'react';
import VaccinationInfo from './VaccinationInfo';

const VaccinationDetails = () => {
  return (
    <div>
      <div className="vaccination-div vaccination-details-div">
        <VaccinationInfo />
      </div>
    </div>
  );
};

export default VaccinationDetails;